import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import ActionButton from '../../../Components/Common/ActionButton';
import { SkeletonCard } from '../../../Components/Common/Skeleton';
import { EmptyState } from '../../../Components/Common/ListStates';

const SupportDocs = ({
  documents = [],
  isLoading,
  searchText,
  onSearchChange,
  onClearSearch,
  showDmutBadge = false,
}) => {
  const openDocument = url => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Row>
      <Col xs={12}>
        <div className='d-flex flex-wrap gap-3 mb-4'>
          <div
            className='position-relative'
            style={{ width: '250px', maxWidth: '100%' }}
          >
            <i className='ri-search-line position-absolute top-50 start-0 translate-middle-y ms-2 text-muted'></i>
            <Input
              type='text'
              placeholder='Search...'
              className='ps-5'
              value={searchText}
              onChange={e => onSearchChange?.(e.target.value)}
            />
          </div>
          <ActionButton
            variant='tertiary'
            icon='ri-filter-off-line'
            onClick={onClearSearch}
            disabled={!searchText}
          >
            Clear Filter
          </ActionButton>
        </div>

        {isLoading ? (
          <>
            <SkeletonCard lines={1} className='border mb-3' />
            <SkeletonCard lines={1} className='border mb-3' />
          </>
        ) : documents.length === 0 ? (
          <EmptyState
            compact
            icon='ri-file-text-line'
            title='No documents available'
            emptyHint='No supporting documents were selected for this procurement invitation.'
            filteredHint='No documents match your search.'
            hasFilters={Boolean(searchText)}
            onClear={onClearSearch}
          />
        ) : (
          documents.map(doc => (
            <div
              key={doc.id}
              className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3'
            >
              <div className='d-flex align-items-center gap-3'>
                <div
                  className='bg-light rounded d-flex align-items-center justify-content-center flex-shrink-0'
                  style={{ width: '48px', height: '48px' }}
                >
                  <i
                    className={`${
                      doc.isMasterDocument
                        ? 'ri-file-text-line text-success'
                        : 'ri-file-text-line text-primary'
                    } fs-24`}
                  ></i>
                </div>
                <div style={{ minWidth: 0, overflowWrap: 'anywhere' }}>
                  <h6 className='fw-medium text-dark mb-1'>
                    {doc.documentName || doc.customFileName || '-'}
                  </h6>
                  <div className='d-flex flex-wrap align-items-center gap-2 small'>
                    <span
                      className={`badge ${
                        doc.isMasterDocument
                          ? 'bg-success-subtle text-success'
                          : 'bg-primary-subtle text-primary'
                      }`}
                    >
                      {doc.isMasterDocument
                        ? 'Master Document'
                        : 'Upload Custom'}
                    </span>
                    {(doc.lastUpdated || doc.createdDate) && (
                      <span className='text-muted'>
                        {doc.lastUpdated
                          ? `Updated: ${doc.lastUpdated}`
                          : `Created: ${doc.createdDate}`}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className='d-flex flex-wrap align-items-center justify-content-between gap-2 gap-md-4'>
                {showDmutBadge && doc.isShowToDMUT && (
                  <span className='small text-dark fw-medium d-inline-flex align-items-center gap-1'>
                    <span className='text-danger'>*</span> Show to Registered
                    Supplier
                  </span>
                )}
                <ActionButton
                  variant='secondary'
                  icon='ri-eye-line'
                  onClick={() => openDocument(doc.actualUrl)}
                  disabled={!doc.actualUrl}
                >
                  View
                </ActionButton>
              </div>
            </div>
          ))
        )}
      </Col>
    </Row>
  );
};

export default SupportDocs;
